import React from 'react';
import { Navigate } from 'react-router';
import { HIDE_SYSTEM_ROUTE } from '../../configs';
import { GUEST_MODULE, SYSTEM_MODULE } from '../../configs/moduleNames';
import LogoutPage from './components/LogoutPage';
import LoginPage from './components/LoginPage';
import NotificationPage from './components/NotificationPage';
import EsiaCallback from './components/EsiaCallback';
import { UserProfilePopUp } from './components/UserProfilePopUp';

const routes = [
  {
    path: '/logout',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    loginRequired: true,
    component: LogoutPage,
    weight: 999,
  },
  {
    path: '/invite/:id/esia-callback',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    component: EsiaCallback,
    loginRequired: false,
    weight: 999,
  },
  {
    path: '/invite/:id/esia-callback',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    component: () => {
      const pathParts = window.location.pathname.split('/');
      const id = pathParts[2];
      return <Navigate to={`/user-profile?invite_Id=${id}`} />;
    },
    loginRequired: true,
    weight: 999,
  },
  {
    path: '/user-profile/:id?',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    loginRequired: true,
    component: UserProfilePopUp,
    weight: 999,
  },
  {
    path: '/esia-callback',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    loginRequired: false,
    component: EsiaCallback,
    weight: 999,
  },
  {
    path: '/esia-callback',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    loginRequired: true,
    component: () => <Navigate to="/application" />,
    weight: 999,
  },
  {
    path: '/logout',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    loginRequired: false,
    component: LogoutPage,
    weight: 999,
  },
  {
    path: '/',
    name: 'menu.login',
    permission: GUEST_MODULE,
    loginRequired: false,
    component: LoginPage,
    weight: 999,
  },
  {
    path: '/invite/:id?',
    name: 'menu.login',
    permission: GUEST_MODULE,
    loginRequired: false,
    component: LoginPage,
    weight: 999,
  },
  // {
  //   path: '/registration',
  //   name: 'menu.registration',
  //   permission: GUEST_MODULE,
  //   hideOnMenu: HIDE_SYSTEM_ROUTE,
  //   loginRequired: false,
  //   component: RegistrationPage,
  //   weight: 999,
  // },
  {
    path: '/notification',
    name: 'menu.logout',
    permission: SYSTEM_MODULE,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    icon: 'pe-7s-power',
    loginRequired: true,
    component: NotificationPage,
    weight: 999,
  },
];

export default routes;
